import { render } from "./App.vue?vue&type=template&id=751c9aae"
const script = {}

import exportComponent from "/var/www/clients/client5/web28/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__